import PropTypes from "prop-types";
import { alignItems } from "../../consts";

import { FlexContainers, IconButton, Paragraph2, SVG, WrapperContainer } from "../../components";
import {
  NotificationWrapper,
  NotificationContainer,
  InfoContianer,
  Title,
  NotificationContentWrapper
} from "./styled";

const Notification = ({ id, type = "error", title, message, closeNotification, Component }) => {
  return (
    <NotificationWrapper>
      <NotificationContainer id={id} type={type}>
        <WrapperContainer mt={4}>
          {type === "success" ? <SVG.NotificationSuccessIcon /> : <SVG.NotificationErrorIcon />}
        </WrapperContainer>

        <NotificationContentWrapper>
          <InfoContianer>
            {title && <Title>{title}</Title>}

            <WrapperContainer
              Container={FlexContainers.FlexColumnStart}
              alignItems={alignItems.start}
              gap={4}
              width="100%">
              <Paragraph2 dangerouslySetInnerHTML={{ __html: message }} />

              {Component && Component}
            </WrapperContainer>
          </InfoContianer>
        </NotificationContentWrapper>

        {closeNotification && (
          <WrapperContainer ml={21} mr={-9} mt={-9}>
            <IconButton>
              <SVG.NotificationCloseIcon onClick={() => closeNotification()} />
            </IconButton>
          </WrapperContainer>
        )}
      </NotificationContainer>
    </NotificationWrapper>
  );
};

Notification.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  type: PropTypes.string,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  closeNotification: PropTypes.func,
  Component: PropTypes.oneOfType([PropTypes.object, PropTypes.node])
};

export default Notification;
